module.exports = __webpack_public_path__ + "media/state-press_800.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/state-press_800.jpg
// module id = 52
// module chunks = 0